import inRange from 'lodash-es/inRange';

export default (value) => {
  let class_name = '';

  if (inRange(value, 110, 200)) {
    class_name = 'h1';
  } else if (inRange(value, 85, 110)) {
    class_name = 'h2';
  } else if (inRange(value, 60, 85)) {
    class_name = 'h3';
  } else if (inRange(value, 45, 60)) {
    class_name = 'h4';
  } else if (inRange(value, 38, 45)) {
    class_name = 'h5';
  } else if (inRange(value, 27, 38)) {
    class_name = 'h6';
  } else if (inRange(value, 16, 27)) {
    class_name = 'h7';
  } else if (inRange(value, 8, 16)) {
    class_name = 'p';
  }

  return class_name;
};
